// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgEngineeredPrivateDeal = ({
  color = 'currentColor',
  size = 20
}: IconProps) => (
  <svg
    viewBox="0 0 74 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <g clipPath="url(#engineeredPrivateDeal_svg__a)">
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.65s2.378-.343 3.07-1.057c.69-.715 1.022-3.173 1.022-3.173s.338 2.464 1.024 3.173c.685.709 3.069 1.057 3.069 1.057s-2.366.33-3.07 1.058c-.703.727-1.023 3.173-1.023 3.173s-.287-2.413-1.023-3.173C2.334 11.948 0 11.65 0 11.65Z"
      />
      <path
        opacity={0.75}
        d="M11.774 6.416c0-.305-.23-.495-.447-.496-.215 0-.447.19-.447.496 0 .305.231.496.447.496v1l-.148-.008c-.73-.077-1.299-.714-1.299-1.488 0-.826.648-1.496 1.447-1.496l.148.008c.73.077 1.299.713 1.299 1.488 0 .825-.648 1.495-1.447 1.496v-1c.216 0 .447-.192.447-.496Z"
      />
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.861 4.173s1.784-.258 2.302-.794c.519-.535.768-2.379.768-2.379s.253 1.848.767 2.38c.514.531 2.302.793 2.302.793s-1.774.247-2.302.793c-.528.545-.767 2.38-.767 2.38s-.216-1.81-.768-2.38c-.551-.57-2.302-.793-2.302-.793Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.345 16.885s1.178-.16 1.535-.529c.356-.368.511-1.586.511-1.586s.17 1.234.512 1.586c.34.353 1.535.529 1.535.529s-1.193.175-1.535.529C16.56 17.767 16.39 19 16.39 19s-.17-1.234-.511-1.586c-.341-.353-1.535-.53-1.535-.53Z"
      />
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74 11.65s-2.416-.343-3.119-1.057c-.702-.715-1.04-3.173-1.04-3.173s-.342 2.464-1.039 3.173c-.697.709-3.119 1.057-3.119 1.057s2.404.33 3.119 1.058c.715.727 1.04 3.173 1.04 3.173s.292-2.413 1.04-3.173C71.628 11.948 74 11.65 74 11.65Z"
      />
      <path
        opacity={0.75}
        d="M62.02 6.415c0-.289.227-.494.47-.495.243 0 .47.206.47.495 0 .29-.226.497-.47.497v1l.15-.008a1.487 1.487 0 0 0 1.32-1.489c0-.825-.658-1.495-1.47-1.495l-.15.008a1.486 1.486 0 0 0-1.32 1.487c0 .826.658 1.496 1.47 1.497v-1a.484.484 0 0 1-.47-.497ZM48.788 13.52c0-.083.062-.122.103-.122.04 0 .103.04.103.122 0 .084-.062.121-.103.122v1a1.11 1.11 0 0 0 1.097-1.007l.006-.115c0-.62-.494-1.122-1.103-1.122s-1.103.503-1.103 1.122l.006.115a1.11 1.11 0 0 0 1.097 1.007v-1c-.04 0-.102-.038-.102-.122ZM26 13.52c0-.083.062-.122.103-.122.04 0 .102.039.102.122 0 .083-.062.121-.102.121v1c.57 0 1.04-.44 1.096-1.006l.006-.115c0-.62-.493-1.122-1.102-1.122-.61 0-1.103.503-1.103 1.122l.006.115a1.11 1.11 0 0 0 1.097 1.006v-1c-.04 0-.103-.038-.103-.12Z"
      />
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.835 4.173s-1.812-.258-2.34-.794C51.97 2.844 51.717 1 51.717 1s-.257 1.848-.78 2.38c-.522.531-2.339.793-2.339.793s1.803.247 2.34.793c.536.545.78 2.38.78 2.38s.218-1.81.779-2.38c.56-.57 2.339-.793 2.339-.793Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.424 16.885s-1.197-.16-1.56-.529c-.361-.368-.52-1.586-.52-1.586s-.172 1.234-.52 1.586c-.346.353-1.558.529-1.558.529s1.211.175 1.559.529c.348.353.52 1.586.52 1.586s.173-1.234.52-1.586c.346-.353 1.559-.53 1.559-.53ZM43.375 8.4C43.35 4.86 41.177 2 38.5 2s-4.85 2.86-4.875 6.4C32.727 8.4 32 9.18 32 10.145v6.11c0 .963.727 1.745 1.625 1.745h9.75c.897 0 1.625-.782 1.625-1.746v-6.109c0-.964-.728-1.745-1.625-1.745Zm-2.45 0c-.128-2.235-1.165-3.977-2.425-3.977-1.26 0-2.297 1.742-2.424 3.977h4.848ZM38.5 11.032a1.29 1.29 0 0 1 .65 2.411v1.68a.648.648 0 0 1-.65.646.648.648 0 0 1-.65-.646v-1.68a1.29 1.29 0 0 1 .65-2.411Z"
      />
    </g>
    <defs>
      <clipPath id="engineeredPrivateDeal_svg__a">
        <path fill="#fff" d="M0 0h74v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgEngineeredPrivateDeal
